/**
 * This file hold masterdata table related classes
 */

import _ from 'lodash';

class MasterdataClass{
    constructor(){
        this.data = [];
    }

    static getInstance(){
        return new MasterdataClass();
    }

    /**
     * Set the data list to the class property
     * @param Object
     */
    set(data){
        if(_.isObject(data) && !_.isUndefined(data.response)){
            const response = data.response;
            let list = [];
            if(!_.isUndefined(data.response.data) && Object.keys(response).length > 0 && response.status === 200 && Object.keys(response.data).length > 0){
                list = response.data;
            }
            this.data = list;
        }
        if(_.isArray(data)){
            this.data = data;
        }
    }

    /**
     * get the data Masterdatalist
     *
     * @return array
     */
    getAll(){
        return this.data;
    }

    /**
     * get the Id for given name
     *
     * @param string
     * @return string
     */
    getIdByName(name){
        const data = _.find(this.data, {[this.nameKey]: name});
        return (data) ? data[this.idKey]: '';
    }

    /**
     * get the name for given id
     *
     * @param string
     * @return string
     */
    nameById(id){
        const data = _.find(this.data, {[this.idKey]: id});
        return (data) ? data[this.nameKey]: '-';
    }

    /**
     * get the name for given id
     * If given argument is array, then name with comma separator would return
     * If given argument is string, return simple name
     *
     * @param string|array
     * @return string
     */
    getNameById(id){

        if(_.isArray(id)){
            const self = this;
            const nameArr = [];
            id.forEach((singleId) => {
                const name = self.nameById(singleId);
                if(!_.isEmpty(name) && name !== '-')
                {
                    nameArr.push(name);
                }
            });
            return !_.isEmpty(nameArr) ? nameArr.join(', ') : '-';
        }

        return this.nameById(id);
    }

}

/**
 * Handle Utility masterdata related functionalities
 */
class UtilityClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'utilityId';
        this.nameKey = 'utilityName';
    }

    static getInstance(){
        return new UtilityClass();
    }

    /**
     * get the name for given id
     *
     * @param string|array
     * @return string
     */
    getNameById(id){
        const name = super.getNameById(id);
        return !_.isEmpty(name) && name !== '-' ? name : '';
    }
}

/**
 * Handle Country masterdata related functionalities
 */
class CountryClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'countryId';
        this.nameKey = 'countryName';
    }

    static getInstance(){
        return new CountryClass();
    }
}

/**
 * Handle Roles masterdata related functionalities
 */
class RoleClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'roleId';
        this.nameKey = 'roleName';
    }

    static getInstance(){
        return new RoleClass();
    }
}

/**
 * Handle City masterdata related functionalities
 */
class CityClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'cityId';
        this.nameKey = 'cityName';
    }

    static getInstance(){
        return new CityClass();
    }
}

/**
 * Handle City masterdata related functionalities
 */
class StateClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'stateId';
        this.nameKey = 'stateName';
    }

    static getInstance(){
        return new StateClass();
    }
}

/**
 * Handle City masterdata related functionalities
 */
class CustomerClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'customerId';
        this.nameKey = 'customerName';
    }

    static getInstance(){
        return new CustomerClass();
    }
}

/**
 * Handle User masterdata related functionalities
 */
class UserClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'userId';
        this.nameKey = 'userName';
    }

    static getInstance(){
        return new UserClass();
    }
}

/**
 * Handle User masterdata related functionalities
 */
class DeviceStatusClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'statusId';
        this.nameKey = 'statusName';
    }

    static getInstance(){
        return new DeviceStatusClass();
    }
}

/**
 * Handle User masterdata related functionalities
 */
class PropertyStatusClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'statusId';
        this.nameKey = 'statusName';
    }

    static getInstance(){
        return new PropertyStatusClass();
    }
}
/**
 * Handle City masterdata related functionalities
 */
class PincodeClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'pincodeId';
        this.nameKey = 'pincodeName';
    }

    static getInstance(){
        return new PincodeClass();
    }
}

/**
 * Handle City masterdata related functionalities
 */
class PropertySubTypeClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'propertySubTypeId';
        this.nameKey = 'propertySubTypeName';
    }

    static getInstance(){
        return new PropertySubTypeClass();
    }
    /**
     * get the property Sub Types list for given property Type ID
     *
     * @param string
     * @return string
     */
    getTypeByPropertyTypeId(propertyTypeId){
        const propertySubTypesArr = _.filter(this.data, {propertyTypeId: propertyTypeId});
        return (propertySubTypesArr) ? propertySubTypesArr: [];
    }
}

/**
 * Handle City masterdata related functionalities
 */
class PropertyTypeClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'propertyTypeId';
        this.nameKey = 'propertyTypeName';
    }

    static getInstance(){
        return new PropertyTypeClass();
    }
}

/**
 * Handle Zone masterdata related functionalities
 */
class ZoneClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'zoneId';
        this.nameKey = 'zoneName';
    }

    static getInstance(){
        return new ZoneClass();
    }
}

/**
 * Handle Site masterdata related functionalities
 */
class SiteClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'locationId';
        this.nameKey = 'locationName';
    }

    static getInstance(){
        return new SiteClass();
    }
}

/**
 * Handle Location masterdata related functionalities
 */
class LocationClass extends MasterdataClass{

    constructor(){
        super();
        this.idKey = 'siteId';
        this.nameKey = 'siteName';
    }

    static getInstance(){
        return new LocationClass();
    }
}

// Export the all class
export{
    MasterdataClass as Masterdata,
    CityClass as City,
    StateClass as State,
    UtilityClass as Utility,
    CustomerClass as Customer,
    UserClass as User,
    DeviceStatusClass as DeviceStatus,
    PropertyStatusClass as PropertyStatus,
    PincodeClass as Pincode,
    PropertySubTypeClass as PropertySubType,
    PropertyTypeClass as PropertyType,
    CountryClass as Country,
    SiteClass as Site,
    LocationClass as Location,
    ZoneClass as Zone,
    RoleClass as Role,
}
